import React, {useEffect, useMemo} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import { selectedModalName } from "../../../redux/modal/selectors";
import {SignUpModal} from "../../Modals/SignUpModal";
import {SignUpAgreementModal} from "../../Modals/SignUpAgreementModal";
import {SignUpActivationCodeModal} from "../../Modals/SignUpActivationCodeModal";
import {SignUpAllSetModal} from "../../Modals/SignUpAllSetModal";
import {MarginalTaxRateModal} from "../../Modals/MarginalTaxRateModal";
import {EDeliveryAgreementModal} from "../../Modals/EDeliveryAgreementModal"
import {BeaconModal} from "./BeaconModal";
import {modalActions} from "../../../redux/root-action";
import {UseAppDispatch} from "../../../redux/configure-store";
import {DailyPricesInvestmentOptionsModal} from "../../Modals/DailyPricesInvestmentOptionsModal";
import {SavedModal} from "../../Modals/savedModal";
import {ConfirmSaveModal} from "../../Modals/ConfirmSaveModal";
import {MonthlyPerformanceInvestmentModal} from "../../Modals/MonthlyPerformanceInvestmentModal";
import {SignUpAuthenticatedModal} from "../../Modals/SignUpAuthenticatedModal";

const modalComponentMap: { [key: string]: any } = {
    SIGN_UP_MODAL: SignUpModal,
    SIGN_UP_AGREEMENT_MODAL: SignUpAgreementModal,
    SIGN_UP_ACTIVATION_CODE_MODAL: SignUpActivationCodeModal,
    SIGN_UP_ALL_SET_MODAL: SignUpAllSetModal,
    SIGN_UP_AUTHENTICATED_MODAL: SignUpAuthenticatedModal,
    MARGINAL_TAX_RATE_MODAL: MarginalTaxRateModal,
    E_DELIVERY_AGREEMENT_MODAL:EDeliveryAgreementModal,
    DAILY_PRICES_INVESTMENT_OPTIONS_MODAL: DailyPricesInvestmentOptionsModal,
    MONTHLY_PERFORMANCE_INVESTMENT_OPTIONS_MODAL: MonthlyPerformanceInvestmentModal,
    SAVED_MODAL: SavedModal,
    CONFIRM_SAVE_MODAL: ConfirmSaveModal
};

export const Modal = () => {
    const dispatch = UseAppDispatch();
    const modalName = useSelector(selectedModalName);
    const ModalComponent = modalComponentMap[modalName];

    const dispatchOverlayLoad = (overlay: String) => {
        try {
            const event = new CustomEvent("overlayLoad", {
                detail: {
                    overlay: overlay
                }
            });
            document.body.dispatchEvent(event);
        } catch (e) {
        }
    }

    useEffect(() => {
        // Gets the beacon-modal instance
        const modalInstance = document.getElementById(modalName);
        // Adds close event listener
        modalInstance && modalInstance.addEventListener('close', () => {
            if(modalName){
                dispatch(modalActions.closeModal());
            }
        });
    })
    const handleCloseModal = () => {
        const modal: BeaconModal | null = document.querySelector(`#${modalName}`);
        if (modal !== null) modal.close();
        dispatch(modalActions.closeModal());
    };
    return (
        <React.Fragment>
            {modalName &&
                <ModalComponent modalName={modalName} handleCloseModal={handleCloseModal} dispatchOverlayLoad={dispatchOverlayLoad}/>
            }
        </React.Fragment>
    )

}
